import { Skeleton, TableBody, TableHead, TableRow } from '@mui/material';
import { StyledHeaderCell, StyledTable, StyledTableCell, StyledTableRow } from './NsnTable';

const SKELETON_ROWS = 3;

export const SourcingOpportunitiesSkeleton = () => {
  return (
    <StyledTable size='small'>
      <TableHead>
        <TableRow>
          <StyledHeaderCell sx={{ width: '50%', paddingLeft: '8px' }}>Supplier</StyledHeaderCell>
          <StyledHeaderCell sx={{ width: '140px' }}>Part Number</StyledHeaderCell>
          <StyledHeaderCell sx={{ width: '150px' }}>Price / Availability</StyledHeaderCell>
          <StyledHeaderCell sx={{ width: '120px', textAlign: 'center' }}>Confidence</StyledHeaderCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {Array.from({ length: SKELETON_ROWS }, (_, index) => (
          <StyledTableRow key={index}>
            <StyledTableCell sx={{ paddingLeft: '8px' }}>
              <Skeleton variant='text' width='45%' height={16} />
              <Skeleton variant='text' width='92%' height={11} />
              <Skeleton variant='text' width='68%' height={11} />
            </StyledTableCell>
            <StyledTableCell>
              <Skeleton variant='text' width={90} height={16} />
            </StyledTableCell>
            <StyledTableCell>
              <Skeleton variant='text' width={80} height={16} />
            </StyledTableCell>
            <StyledTableCell sx={{ textAlign: 'center' }}>
              <Skeleton variant='rounded' width={54} height={14} sx={{ margin: '0 auto' }} />
            </StyledTableCell>
          </StyledTableRow>
        ))}
      </TableBody>
    </StyledTable>
  );
};
